<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="text-center">Create a trophy</h2>
        <span class="failure">{{ failureMessage }}</span>
        <br>
        <b-form class="">
          <b-form-group id="name" label-for="name">
            <span>Trophy name</span>
            <b-form-input 
              id="name"
              v-model="form.name.value" 
              :state="form.name.error.state"
              placeholder="name"
              required
            />
            <b-form-invalid-feedback :state="form.name.error.state">
              {{ form.name.error.value }}
            </b-form-invalid-feedback>
            <br>
            <span>Club</span>
            <b-form-input 
              id="club"
              v-model="club.name" 
              readonly
            />
            <br>
            <b-form-checkbox
              id="isPrivate"
              v-model="club.isPrivate"
              name="isPrivate"
              :value="true"
              :unchecked-value="false"
              :disabled="true"
            >
            <span>Is it a private trophy?</span>&nbsp;<fa-icon icon="question-circle" v-tooltip:right="`Same setting as the club. Public trophies can be joined by anyone. They appear publicly on the app. Private trophies can only be joined by members of the club. They don't appear publicly on the app.`" />
          </b-form-checkbox>
          </b-form-group>
          <br>
          <h4>Races</h4>
          <span>A trophy is made of one or multiple races that have to be performed by riders within specific dates. Riders score points on each race. The overall ranking is made of the sum of scored points on each race.</span>
          <b-form-group id="steps" label-for="steps">
          <br>
          <table class="full-width">
            <thead>
            <tr>
              <th>Step</th>
              <th>Race</th>
              <th v-if="form.steps.value.length > 2">Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr 
              v-for="(step, index) in form.steps.value"
              :key="step.race ? step.race.id : step.race"
            >
                <td class="padding-top">
                  <span>Race {{ index + 1 }}</span>
                </td>
                <td class="padding-top">
                  <multiselect
                    v-model="step.race"
                    :options="options"
                    label="displayedName"
                    track-by="id"
                    placeholder="Search for a race"
                    select-label=""
                    :multiple="false"
                    :searchable="true"
                    :hide-selected="false"
                    :clear-on-select="true"
                    @search-change="searchRaces"
                    @select="onSelect"
                  >
                  </multiselect>
                  <v-date-picker v-model="step.range" is-range mode="date" />
                </td>
                <td 
                  v-if="(index === form.steps.value.length - 1) && form.steps.value.length > 1"
                  class="padding-top"
                >
                  <fa-icon 
                    icon="times"
                    class="fa-2x clickable"
                    @click="deleteConfig(form.steps.value, index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <fa-icon 
            icon="plus"
            class="fa-2x clickable"
            @click="addConfig(form.steps.value)"
          />
            <b-form-invalid-feedback :state="form.steps.error.state">
              {{ form.steps.error.value }}
            </b-form-invalid-feedback>
          </b-form-group>
          <br><br><br>
          <c-button :onClick="onCancel" variant="secondary">Cancel</c-button>
          <c-button :onClick="onNext" variant="primary" class="right-align">Next</c-button>
          <br>
          <span class="success right-align">{{ formSuccess }}</span>
          <span class="failure right-align">{{ formFailure }}</span>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import Multiselect from 'vue-multiselect';
  import VDatePicker from 'v-calendar/lib/components/date-picker.umd'

  export default {
    name: 'CreateTrophy',
    components: { CButton, Multiselect, VDatePicker },
    props: {
      id: String
    },
    data() {
      return {
        club: {},
        form: {
          name: {
            value: '',
            error: {}
          },
          steps: {
            value: [
              {
                race: null,
                range: {
                  start: null,
                  end: null
                }
              },
            ],
            error: {}
          },
        },
        options: [],
        formSuccess: '',
        formFailure: '',
        failureMessage: ''
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})
      
      await this.getClub()
      await this.searchRaces('')
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      async getClub() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getClub.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getClub) {
          this.club = Object.assign({}, this.club, result.data.getClub)
        }
      },
      addConfig(steps) {
        steps.push({
          race: null,
          range: {
            start: null,
            end: null
          }
        })
      },
      deleteConfig(steps, index) {
        steps.splice(index, 1)
      },
      onCancel(event) {
        this.$router.push({ name: 'Club', params: { id: this.id } });
      },
      async onNext() {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        for (let i=0; i < this.form.steps.value.length; i++) {
          delete this.form.steps.value[i].race.displayedName
        }

        try {
          const result = await this.$apollo.mutate({
            client: 'private',
            mutation: require('@/graphql/createTrophy.graphql'),
            variables: {
              name: this.form.name.value,
              steps: this.form.steps.value,
              clubId: this.id
            }
          });

          if (result.errors) {
            const e = result;
            if (e.body) {
              if (e.body.message) {
                this.formFailure = e.body.message;
              }
              if (e.body.details) {
                e.body.details.map(detail => {
                  detail.path.map(path => {
                    this.$set(this.form[path], 'error', {state: false, value: detail.message})
                  })
                })
              }
            }
          } else {
            this.formSuccess = "Trophy successfully created";
            this.$router.push({ name: 'Trophy', params: { id: result.data.createTrophy.id }});
          }
        } catch (err) {
          this.formFailure = 'Error on a field. Please make sure all fields are properly entered.'
        }
      },
      async searchRaces(val) {
        this.options = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/searchRaces.graphql'),
          variables: {
            search: val,
            limit: 10,
          }
        });

        if (result && result.data && result.data.searchRaces) {
          for (let i=0; i < result.data.searchRaces.length; i++) {
            const race = result.data.searchRaces[i]
            const displayedName = `${race.name} ${race.isEBike ? '(E-Bike)' : ''} - ${(race.itineary.length/2).toFixed(0)} stages - Created by ${race.createdBy.stravaDetails.firstname} ${race.createdBy.stravaDetails.lastname}`
            this.options.push({ id: race.id, displayedName })
          }
        }
      },
      async onSelect(val) {
        this.options = []

        await this.searchRaces('')
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__option--highlight {
    background-color: #ffc859;
    color: #000000;
  }
  .multiselect__select {
    background-color: #ffc859;
    color: #000000;
  }
</style>
